import { render } from "./BpmnSidePanel.vue?vue&type=template&id=ee5242c8&scoped=true"
import script from "./BpmnSidePanel.vue?vue&type=script&lang=js"
export * from "./BpmnSidePanel.vue?vue&type=script&lang=js"

import "./BpmnSidePanel.vue?vue&type=style&index=0&id=ee5242c8&scoped=true&lang=css"
import "./BpmnSidePanel.vue?vue&type=style&index=1&id=ee5242c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee5242c8"]])

export default __exports__